import { render, staticRenderFns } from "./SpatialTabs.vue?vue&type=template&id=56c55c30"
import script from "./SpatialTabs.vue?vue&type=script&lang=js"
export * from "./SpatialTabs.vue?vue&type=script&lang=js"
import style0 from "./SpatialTabs.vue?vue&type=style&index=0&id=56c55c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports